import auth from './auth.json';
import form from './form.json';
import base from './base.json';

const en = {
    ...auth,
    ...form,
    ...base,
};

export default en;